import React from 'react';
import PropTypes from 'prop-types';
import styles from './Skeleton.module.scss';

const Skeleton = (props) => {
  const skeletonStyle = {
    width: props.fullWidth ? '100%' : props.width,
    height: props.height ? props.height : props.big ? 32 : 16
  };

  return (
    <div>
      {[...new Array(props.lines)].map((line, i) => (
        <div key={i} className={styles.line} style={skeletonStyle}>
          {props.children}
        </div>
      ))}
    </div>
  );
};

Skeleton.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  lines: PropTypes.number,
  fullWidth: PropTypes.bool,
  big: PropTypes.bool,
  children: PropTypes.node
};

Skeleton.defaultProps = {
  lines: 1
};

export default Skeleton;
